import React from 'react';

import { usePlayerContext } from '../Context';
import { Control, Events, State, ControlComponentItem } from '../../types/player';
import Play from '../controls/Play';
import QualityLevelSelector from '../controls/QualityLevelsSelector';
import Pip from '../controls/Pip';
import Volume from '../controls/Volume';
import Fullscreen from '../controls/Fullscreen';
import AudioTracksSelector from '../controls/AudioTracksSelector';
import VideoTracksSelector from '../controls/VideoTracksSelector';
import TextTracksSelector from '../controls/TextTracksSelector';
import PlaybackRatesSelector from '../controls/PlaybackRatesSelector';
import SeekControlForward from '../controls/SeekControlForward';
import SeekControlRewind from '../controls/SeekControlRewind';
import TimeInfo from '../controls/TimeInfo';
import SubMenu from '../controls/SubMenu';
import Cta from '../controls/Cta';
import Title from '../controls/Title';
import Logo from '../controls/Logo';
import AirPlay from '../controls/AirPlay';
import PluginControlContainer from '../controls/PluginControlContainer';
import LiveDVRIndicator from '../controls/LiveDVRIndicator';

import Utils from '../../utils/Utils';
import PluginInterface from '../../sdk/plugins/PluginInterface';

const ControlList = ({
  controls,
  position,
}: {
  controls: ControlComponentItem[];
  position?: string | null;
}) => {
  const { sdk } = usePlayerContext();

  const ControlComponents: { [key in Control]?: () => JSX.Element | null } = {
    [Control.PLAY]: Play,
    [Control.VOLUME]: Volume,
    [Control.FULLSCREEN]: Fullscreen,
    [Control.PIP]: Pip,
    [Control.QUALITYLEVELS_SELECTOR]: QualityLevelSelector,
    [Control.AUDIOTRACKS_SELECTOR]: AudioTracksSelector,
    [Control.VIDEOTRACKS_SELECTOR]: VideoTracksSelector,
    [Control.TEXTTRACKS_SELECTOR]: TextTracksSelector,
    [Control.PLAYBACKRATES_SELECTOR]: PlaybackRatesSelector,
    [Control.SEEK_CONTROL_FORWARD]: SeekControlForward,
    [Control.SEEK_CONTROL_REWIND]: SeekControlRewind,
    [Control.TIME_INFO]: TimeInfo,
    [Control.SUB_MENU]: SubMenu,   
    [Control.TITLE]: Title,    
    [Control.AIR_PLAY]: AirPlay,
    [Control.LIVE_DVR_INDICATOR]: LiveDVRIndicator
  };

  const renderControls = () => {
    if (!controls || controls.length === 0) return <></>;
    let render = controls.map((control: ControlComponentItem) => {
      let name: Control = control.name as Control;
      const ControlComponent = ControlComponents[name];
      let key = name + ( control.pluginName ? '-' + control.pluginName + '-' + control.controlName  : '');      
      if(name == Control.PLUGIN_SKELETON) 
        return <PluginControlContainer key={key} pluginName={control.pluginName || ''} controlName={control.controlName || ''} plugin={control.plugin as PluginInterface} />;
      if (ControlComponent) return <ControlComponent key={key} />;
      return <></>;
    });
    if (render && position) {
      return (
        <div
          //tabIndex={ 0 }
          className={`${sdk.getClassNamePrefix()}-player-controls-${Utils.optionsToClassName(position)}`}
        >
          {render}
        </div>
      );
    }
    return render;
  };

  return <>{renderControls()}</>;
};

export default ControlList;
